<template>
  <Button
    :to="{
      name: 'projects'
    }"
    variant="dark"
    icon="projects"
    radius
  >
    サイト一覧
  </Button>
</template>

<script>
import Button from '@/components/Button';
export default {
  components: {
    Button
  }
};
</script>
